import { render, staticRenderFns } from "./TagSubItemsOverlay.vue?vue&type=template&id=5c081546&scoped=true"
import script from "./TagSubItemsOverlay.vue?vue&type=script&lang=js"
export * from "./TagSubItemsOverlay.vue?vue&type=script&lang=js"
import style0 from "./TagSubItemsOverlay.vue?vue&type=style&index=0&id=5c081546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c081546",
  null
  
)

export default component.exports